import { useIonModal } from '@ionic/react';
import { FullPost } from 'model';
import { useUpdateClosedForCommentsMutation } from '../api/PostApi';
import { Confirmation } from '../pages/Confirmation';

// eslint-disable-next-line css-modules/no-unused-class
import sharedstyles from '../styles/Shared.module.css';
import { IconButton } from './IconButton';
import { PostContentsToHTML } from './PostContentsToHTML';
import { IconChatbox, IconComments, IconInfo } from './QuirkIcons';
import { TruncatedSummary } from './TruncatedSummary';
interface CloseCommentsType {
	post: FullPost;
	action?: () => void;
}
export const CloseComments: React.FC<CloseCommentsType> = ({ post, action }) => {
	const { closedForComments } = post;
	const [updateClosedForComments] = useUpdateClosedForCommentsMutation();

	const onCloseComments = async () => {
		dismiss();
		await updateClosedForComments({ postid: post._id, closed: !closedForComments });
		action && action();
	};

	const removeTooltip = async (dismiss: () => void) => {
		action && action();
		dismiss();
	};
	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => removeTooltip(dismiss),
		action: () => onCloseComments(),
		actionLabel: !closedForComments ? 'Close Comments' : 'Open Comments ',
		dismissLabel: 'Cancel',
		content: (
			<>
				<h4>Are you sure you want to {!closedForComments ? 'close ' : 'open '}comments on this post?</h4>
				<div className={sharedstyles.modalDescription}>
					<IconInfo size="large" />
					<div>
						{!closedForComments
							? 'People will no longer be able to comment on this post.'
							: 'This will allow people to comment on this post.'}
					</div>
				</div>
				<TruncatedSummary>
					<PostContentsToHTML>{post?.contents}</PostContentsToHTML>
				</TruncatedSummary>
			</>
		)
	});

	return (
		<IconButton
			label={closedForComments ? 'Open Comments' : 'Close Comments'}
			icon={closedForComments ? <IconComments /> : <IconChatbox />}
			onClick={present}
			testId="CloseOpenCommentsButton"
		/>
	);
};
